import { useCallback, type ReactNode } from "react";
import { Stack } from "@mantine/core";
import { CaseImageReportControls } from "./CaseImageReportControls";
import { PendingReportAttachmentNotice } from "./PendingReportAttachmentNotice";

interface CaseFileReportControlsProps {
  fileId: string;
  caption: string;
  includeInReport: boolean;
  readOnly: boolean;
  includeReadOnly?: boolean;
  isFinalized?: boolean;
  finalizedInReport?: boolean;
  onCaptionChange: (fileId: string, caption: string) => void;
  onIncludeInReportChange: (fileId: string, include: boolean) => void;
  actions?: ReactNode;
}

export function CaseFileReportControls(props: CaseFileReportControlsProps) {
  const {
    actions,
    caption,
    fileId,
    includeInReport,
    includeReadOnly,
    isFinalized = false,
    finalizedInReport = false,
    onCaptionChange,
    onIncludeInReportChange,
    readOnly,
  } = props;
  const handleCaptionChange = useCallback(
    (changedFileId: string, changedCaption: string) => {
      onCaptionChange(changedFileId, changedCaption);
    },
    [onCaptionChange]
  );
  return (
    <Stack gap={4}>
      <CaseImageReportControls
        imageId={fileId}
        caption={caption}
        includeInReport={includeInReport}
        readOnly={readOnly}
        includeReadOnly={includeReadOnly}
        onCaptionChange={handleCaptionChange}
        onIncludeInReportChange={onIncludeInReportChange}
        actions={actions}
      />
      <PendingReportAttachmentNotice
        isFinalized={isFinalized}
        includeInReport={includeInReport}
        finalizedInReport={finalizedInReport}
        subject="photo"
      />
    </Stack>
  );
}
